const __filename = "/app/assets/widgets/therapist.js", __dirname = "/app/assets/widgets";
const utm = '?utm_source=therapist&utm_medium=widget&utm_id=reviews'
const ele = document.currentScript || document.scripts.at(-1)
const hostname = new URL(ele.getAttribute('src')).hostname

const params = new URLSearchParams()
for (const key in ele.dataset) {
  !key.startsWith('therapist') && params.set(key, ele.dataset[key])
}

const template = `
  <div>
    <div style="text-align: center; padding: 6px; font-weight: bold; max-width: 1024px;">
      <a href="https://${hostname}/therapists/${ele.dataset.therapistSlug}${utm}">
        Featured on HarleyTherapy.com
      </a>
    </div>
    <iframe
      height="${ele.dataset.includeReviews === 'false' ? '150' : '300'}"
      style="width: 100%"
      scrolling="no"
      title="${ele.dataset.therapistName} - Harley Therapy Platform"
      src="https://${hostname}/therapists/${ele.dataset.therapistSlug}/embed?${params.toString()}"
      frameborder="no"
      loading="lazy"
    >
      <span>
        Check out
        <a href="https://harleytherapy.com/therapists/${ele.dataset.therapistSlug}${utm}">
          ${ele.dataset.therapistName}
        </a> on <a href="https://harleytherapy.com${utm}">Harley Therapy Platform</a>.
      </span>
    </iframe>
  </div>`

ele.insertAdjacentHTML('beforebegin', template)
